// Hook - szczegoly transakcji
// GET /api/ui/sales-crm/deals/{id}

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetDealResponse } from 'api/types/deals';

const getDeal = (id: number): Promise<IGetDealResponse> => axios.get(`/sales-crm/deals/${id}`);

export const useGetDeal = (id: number, options?: UseQueryOptions<IGetDealResponse, IError>) =>
  useQuery<IGetDealResponse, IError>(['sales-crm-deal', id], () => getDeal(id), {
    enabled: id > 0,
    ...options,
  });
